import React from 'react';
import {
  Dialog,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  Box,
  Tooltip,
  Paper,
} from '@mui/material';

import { useState, useEffect, useRef } from 'react';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { poppins400, poppins500, poppins700 } from 'theme/common.style';
import {
  Button,
  useMediaQuery,
  CircularProgress,
  IconButton,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { AGENT_PRIVATE_OFFER } from 'constant/app.config';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import Swal from 'sweetalert2';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InfoIcon from '@mui/icons-material/Info';
import Loading from 'assets/images/loading.png';

const isNotEmptyArray = (arr) =>
  Array.isArray(arr) &&
  arr.length > 0 &&
  !arr.every((item) => Array.isArray(item) && item.length === 0);

const PendingWarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fillOpacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};

const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.459961"
        y="0.370483"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="#DFDFDF"
      />
      <ellipse
        cx="12.981"
        cy="12.5557"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );
};

const ToggleOn = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.460938"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="url(#paint0_linear_9124_97512)"
      />
      <ellipse
        cx="30.0913"
        cy="12.1852"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9124_97512"
          x1="12.7341"
          y1="-1.66162"
          x2="18.2578"
          y2="28.3495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C2AD2" />
          <stop offset="1" stopColor="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const RoundIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0026 2.66732C6.58812 2.66732 5.23156 3.22922 4.23137 4.22941C3.23117 5.22961 2.66927 6.58616 2.66927 8.00065C2.66927 9.41514 3.23117 10.7717 4.23137 11.7719C5.23156 12.7721 6.58812 13.334 8.0026 13.334C9.41709 13.334 10.7736 12.7721 11.7738 11.7719C12.774 10.7717 13.3359 9.41514 13.3359 8.00065C13.3359 6.58616 12.774 5.22961 11.7738 4.22941C10.7736 3.22922 9.41709 2.66732 8.0026 2.66732ZM1.33594 8.00065C1.33594 4.31865 4.3206 1.33398 8.0026 1.33398C11.6846 1.33398 14.6693 4.31865 14.6693 8.00065C14.6693 11.6827 11.6846 14.6673 8.0026 14.6673C4.3206 14.6673 1.33594 11.6827 1.33594 8.00065Z"
        fill="#2F74EE"
      />
      <path
        d="M8 6.66667C8.17681 6.66667 8.34638 6.7369 8.4714 6.86193C8.59643 6.98695 8.66667 7.15652 8.66667 7.33333V11.3333C8.66667 11.5101 8.59643 11.6797 8.4714 11.8047C8.34638 11.9298 8.17681 12 8 12C7.82319 12 7.65362 11.9298 7.5286 11.8047C7.40357 11.6797 7.33333 11.5101 7.33333 11.3333V7.33333C7.33333 7.15652 7.40357 6.98695 7.5286 6.86193C7.65362 6.7369 7.82319 6.66667 8 6.66667ZM9 5C9 5.26522 8.89464 5.51957 8.70711 5.70711C8.51957 5.89464 8.26522 6 8 6C7.73478 6 7.48043 5.89464 7.29289 5.70711C7.10536 5.51957 7 5.26522 7 5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5Z"
        fill="#2F74EE"
      />
    </svg>
  );
};

const InitiatePrivateOffer = ({
  open,
  onClose,
  tableData,
  profileDetails,
  onSubmitOfferAmount,
  getcall,
  setShowConfirmationPopup,
  privateoffer,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // detects screen width < 600px
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const flexStyle = { display: 'flex', alignItems: 'center', gap: '15px' };
  const reqStyle = {
    fontFamily: 'poppins',
    color: '#666666',
    whiteSpace: matches400 ? 'nowrap' : 'wrap',
    fontSize: matches750 ? '14px' : '16px',
    width: '30%',
  };

  const [loading, setLoading] = useState(false);

  const [amount, setAmount] = useState(0);
  const [amountDis, setAmountDis] = useState(false);

  const [error, setError] = useState(false);

  const [formattedTotalAmount, setFormattedTotalAmount] = useState(''); // deposit formatted string
  const [depositAmount, setDepositAmount] = useState(0); // raw number for deposit

  // For percent input
  // const [depo

  const [depositPercent, setDepositPercent] = useState(
    profileDetails?.PropertyDetails?.percentage || ''
  );

  // 🔄 Update depositPercent when profileDetails changes
  useEffect(() => {
    if (privateoffer?.depositPercentage) {
      setDepositPercent(privateoffer?.depositPercentage);
    }
  }, [privateoffer]);

  const [percentDis, setPercentDis] = useState(false);
  const [offerAmount, setOfferAmount] = useState(''); // Formatted offer amount (e.g. "10,000")
  const [numericOfferAmount, setNumericOfferAmount] = useState(0); // Unformatted number for calculations
  const [vendorMessage, setVendorMessage] = useState('');
  const [errors, setErrors] = useState({
    offerAmount: false,
    depositAmount: false,
    settlementDays: false,
    message: false,
  });

  const depositInputRef = useRef(null);

  // const [settlementDays, setSettlementDays] = useState(
  //   profileDetails?.PropertyDetails?.settlementDays
  // );
  const [settlementDays, setSettlementDays] = useState(
    profileDetails?.PropertyDetails?.settlementDays || ''
  );

  // 🔄 Whenever privateoffer changes (after API success),
  // update settlementDays to reflect API response
  useEffect(() => {
    if (privateoffer?.settlementDays) {
      setSettlementDays(privateoffer?.settlementDays);
    }
  }, [privateoffer]);

  const handleSettlementDaysChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only digits
    
    // If they type only zeroes, clear the field and show the error immediately
    if (/^0+$/.test(value)) {
      setSettlementDays('');
      setErrors((prev) => ({ ...prev, settlementDays: true }));
      return;
    }

    setSettlementDays(value);
    
    // Clear error if a valid value is entered
    if (value !== '') {
      setErrors((prev) => ({ ...prev, settlementDays: false }));
    }
  };
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  // const handleDepositPercentChange = (e) => {
  //   let value = e.target.value.replace('%', ''); // Remove '%' symbol
  //   const cursorPos = e.target.selectionStart || 0;

  //   // Allow only numeric input
  //   if (!/^\d*$/.test(value)) return;

  //   // Convert the string value to a number
  //   const percentValue = parseInt(value, 10);

  //   // Cap the percentage at 100, and don't allow negative values
  //   if (percentValue > 100) return;

  //   // Calculate the deposit amount based on the percentage
  //   if (value && !isNaN(percentValue) && percentValue >= 0) {
  //     const depositAmountCalculated = (percentValue / 100) * numericOfferAmount;

  //     if (isNaN(depositAmountCalculated)) {
  //       setFormattedTotalAmount(''); // If calculation fails, clear
  //     } else {
  //       const formattedAmount = depositAmountCalculated.toLocaleString('en-US');
  //       setFormattedTotalAmount(formattedAmount);
  //       setDepositAmount(depositAmountCalculated);
  //     }
  //   } else {
  //     setFormattedTotalAmount(''); // Clear if invalid input
  //     setDepositAmount(0);
  //   }

  //   // Update the deposit percentage (including the "%" symbol)
  //   setDepositPercent(value);

  //   // Cursor positioning fix after formatting
  //   requestAnimationFrame(() => {
  //     const inputEl = depositInputRef.current;
  //     if (!inputEl) return;

  //     let newPos = cursorPos;
  //     if (
  //       value.length < depositPercent.length &&
  //       depositPercent.endsWith('%')
  //     ) {
  //       newPos -= 1; // Handle backspace over %
  //     }

  //     inputEl.setSelectionRange(newPos, newPos);
  //   });
  // };

  const handleDepositPercentChange = (e) => {
    let value = e.target.value.replace('%', ''); // Remove '%' symbol
    const cursorPos = e.target.selectionStart || 0;

    // Allow only numeric input
    if (!/^\d*$/.test(value)) return;

    // Convert the string value to a number
    const percentValue = parseInt(value, 10);

    // Cap the percentage at 100, and don't allow negative values
    if (percentValue > 100) return;

    // Calculate the deposit amount based on the percentage
    if (value && !isNaN(percentValue) && percentValue >= 0) {
      const depositAmountCalculated = (percentValue / 100) * numericOfferAmount;

      // Round to nearest whole number
      const roundedDeposit = Math.round(depositAmountCalculated);

      if (isNaN(roundedDeposit)) {
        setFormattedTotalAmount(''); // If calculation fails, clear
      } else {
        const formattedAmount = roundedDeposit.toLocaleString('en-US');
        setFormattedTotalAmount(formattedAmount);
        setDepositAmount(roundedDeposit);
      }
    } else {
      setFormattedTotalAmount(''); // Clear if invalid input
      setDepositAmount(0);
    }

    // Update the deposit percentage (including the "%" symbol)
    setDepositPercent(value);

    // Cursor positioning fix after formatting
    requestAnimationFrame(() => {
      const inputEl = depositInputRef.current;
      if (!inputEl) return;

      let newPos = cursorPos;
      if (
        value.length < depositPercent.length &&
        depositPercent.endsWith('%')
      ) {
        newPos -= 1; // Handle backspace over %
      }

      inputEl.setSelectionRange(newPos, newPos);
    });
  };

  // const handleOfferAmountChange = (e) => {
  //   const input = e.target;
  //   const rawValue = input.value;

  //   // Remove all non-digit characters
  //   let numeric = rawValue.replace(/\D/g, '');

  //   // ✅ Restrict to maximum 9 digits
  //   if (numeric.length > 9) {
  //     numeric = numeric.slice(0, 9);
  //   }

  //   // If the input is empty or has only zeroes, clear the field
  //   if (!numeric || /^0+$/.test(numeric)) {
  //     setOfferAmount('');
  //     setNumericOfferAmount(null);
  //     setFormattedTotalAmount('');
  //     setDepositAmount(null);
  //     return;
  //   }

  //   const numericValue = Number(numeric);
  //   const formatted = numericValue.toLocaleString('en-US');

  //   setOfferAmount(formatted);
  //   setNumericOfferAmount(numericValue);

  //   if (depositPercent) {
  //     const deposit = Math.round((numericValue * Number(depositPercent)) / 100);
  //     setDepositAmount(deposit);
  //     setFormattedTotalAmount(deposit.toLocaleString('en-US'));
  //   }

  //   // ✅ Cursor position fix
  //   const cursorPos = input.selectionStart || 0;
  //   const digitsBeforeCursor = rawValue
  //     .slice(0, cursorPos)
  //     .replace(/\D/g, '').length;

  //   requestAnimationFrame(() => {
  //     const inputEl = offerInputRef.current?.querySelector('input');
  //     if (!inputEl || typeof inputEl.setSelectionRange !== 'function') return;

  //     let actualCursor = 0;
  //     let digitCount = 0;
  //     for (let i = 0; i < formatted.length; i++) {
  //       if (/\d/.test(formatted[i])) digitCount++;
  //       if (digitCount === digitsBeforeCursor) {
  //         actualCursor = i + 1;
  //         break;
  //       }
  //     }

  //     // If all digits are reached, put cursor at end
  //     if (digitCount < digitsBeforeCursor) {
  //       actualCursor = formatted.length;
  //     }

  //     inputEl.setSelectionRange(actualCursor, actualCursor);
  //   });
  // };

  const handleOfferAmountChange = (e) => {
    const input = e.target;
    const rawValue = input.value;

    // Remove all non-digit characters
    let numeric = rawValue.replace(/\D/g, '');

    // ✅ Restrict to maximum 9 digits
    if (numeric.length > 9) {
      numeric = numeric.slice(0, 9);
    }

    // If the input is empty or has only zeroes, clear the field
    if (!numeric || /^0+$/.test(numeric)) {
      setOfferAmount('');
      setNumericOfferAmount(null);
      setFormattedTotalAmount('');
      setDepositAmount(null);
      return;
    }

    const numericValue = Number(numeric);
    const formatted = numericValue.toLocaleString('en-US');

    setOfferAmount(formatted);
    setNumericOfferAmount(numericValue);

    if (depositPercent) {
      const deposit = Math.round((numericValue * Number(depositPercent)) / 100);
      setDepositAmount(deposit);
      setFormattedTotalAmount(deposit.toLocaleString('en-US'));
    }

    // ✅ Cursor position fix
    const cursorPos = input.selectionStart || 0;
    const digitsBeforeCursor = rawValue
      .slice(0, cursorPos)
      .replace(/\D/g, '').length;

    requestAnimationFrame(() => {
      const inputEl = offerInputRef.current?.querySelector('input');
      if (!inputEl || typeof inputEl.setSelectionRange !== 'function') return;

      let actualCursor = 0;
      let digitCount = 0;
      for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) digitCount++;
        if (digitCount === digitsBeforeCursor) {
          actualCursor = i + 1;
          break;
        }
      }

      // If all digits are reached, put cursor at end
      if (digitCount < digitsBeforeCursor) {
        actualCursor = formatted.length;
      }

      inputEl.setSelectionRange(actualCursor, actualCursor);
    });
  };

  const handleDepositAmountChange = (e) => {
    const input = e.target;
    const rawValue = input.value;

    // If the value is empty, reset to an empty string
    if (rawValue === '') {
      setFormattedTotalAmount(''); // Clear the formatted total amount
      setDepositAmount(0);
      return;
    }

    const numeric = rawValue.replace(/\D/g, ''); // Remove non-numeric characters
    const numericValue = Number(numeric || 0);
    const formatted = numericValue.toLocaleString('en-US'); // Format as number

    setFormattedTotalAmount(formatted); // Set the formatted value
    setDepositAmount(numericValue); // Store the numeric value

    // Clear any other necessary state if needed
    setDepositPercent(''); // Reset percent field (if applicable)

    // Handle cursor position after formatting
    requestAnimationFrame(() => {
      const inputEl = depositInputRef.current?.querySelector('input');
      if (!inputEl || typeof inputEl.setSelectionRange !== 'function') return;

      const cursorPos = input.selectionStart || 0;
      const digitsBeforeCursor = rawValue
        .slice(0, cursorPos)
        .replace(/\D/g, '').length;

      let actualCursor = 0;
      let digitCount = 0;
      while (
        digitCount < digitsBeforeCursor &&
        actualCursor < formatted.length
      ) {
        if (/\d/.test(formatted[actualCursor])) digitCount++;
        actualCursor++;
      }

      inputEl.setSelectionRange(actualCursor, actualCursor);
    });
  };

  const offerInputRef = useRef(null);

  useEffect(() => {
    if (depositPercent) {
      setAmountDis(true);
    } else {
      setAmountDis(false);
    }
  }, [depositPercent]);

  useEffect(() => {
    if (amount) {
      setPercentDis(true);
    } else {
      setPercentDis(false);
    }
  }, [amount]);

  const handleSubmit = async () => {
    const offerAmt = numericOfferAmount;

    // ✅ Calculate deposit amount with special rounding for .5
    const depositAmt = (() => {
      const num = Number(formattedTotalAmount?.toString()?.replace(/,/g, ''));

      // Check if the number has .5 decimal (exactly .5)
      const numStr = num.toString();
      if (numStr.includes('.5') && !numStr.includes('.5.')) {
        return Math.ceil(num); // Round up for .5 (e.g., 23.5 → 24)
      } else {
        return Math.floor(num); // Round down for everything else (e.g., 23.4 → 23)
      }
    })();

    const settlement = Number(settlementDays);
    const messageValid = vendorMessage?.trim() !== '';

    const validationErrors = {
      offerAmount: !offerAmt,
      depositAmount: !depositAmt,
      settlementDays: !settlementDays || Number(settlementDays) <= 0,
      message: !messageValid,
    };

    setErrors(validationErrors);

    const hasError = Object.values(validationErrors).some((val) => val);
    if (hasError) return;

    setLoading(true);

    const propertyId = tableData?.PropertyDetails?.property?.propertyId;
    if (!propertyId) {
      setLoading(false);
      return;
    }

    const payload = {
      propertyId,
      offerPrice: offerAmt,
      isSigned: 0,
      sharedTo: null,
      isActive: 1,
      depositAmount: depositAmt,
      settlementDays: settlement,
      messageToVendor: vendorMessage,
      isConditional: isConditional ? 1 : 0,
      depositPercent: depositPercent,
    };

    try {
      const response = await postApiCall(AGENT_PRIVATE_OFFER, payload);

      if (response.data.status == 1) {
        getcall();
        setIsConditional(1);
        onClose();
        Swal.fire({
          title: response?.data?.heading,
          text: response?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          // ✅ Clear all fields after successful submit
          setOfferAmount('');
          setNumericOfferAmount(0);
          setFormattedTotalAmount('');
          setDepositAmount(0);
          // setDepositPercent("");
          // setSettlementDays("");
          setVendorMessage('');
          setErrors({});
        });

        // ✅ Send offer amount to parent
        if (typeof onSubmitOfferAmount === 'function') {
          onSubmitOfferAmount(offerAmt);
        }
        if (isNotEmptyArray(response?.data?.dataForVendorAcceptanceCertificate))
          Moxoseparationinlisting(
            'dataForVendorAcceptanceCertificatePrivateOffer',
            response?.data?.dataForVendorAcceptanceCertificate
          ); //1
        if (isNotEmptyArray(response?.data?.dataForVendorAckPrivateOffer))
          Moxoseparationinlisting(
            'dataForVendorAckPrivateOffer',
            response?.data?.dataForVendorAckPrivateOffer
          ); //2
      } else {
        console.error('API Error:', response.data.message);
        setError(true);

        // ✅ Added error popup
        Swal.fire({
          title: 'Error',
          text:
            response?.data?.message ||
            'Something went wrong. Please try again.',
          icon: 'error',
          confirmButtonText: 'Close',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    } catch (error) {
      console.error('API Error:', error);
      setError(true);

      // ✅ Added catch error popup
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please try again later.',
        icon: 'error',
        confirmButtonText: 'Close',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const user = tableData?.PropertyDetails?.propertyOwnerDetails?.[0]?.user;
  const fullName =
    user?.userName && user?.userSurName
      ? `${user.userName} ${user.userSurName}`
      : '-';

  const [isConditional, setIsConditional] = React.useState(1); // false = All
  const [showConditionalTooltip, setShowConditionalTooltip] =
    React.useState(false);

  const handleToggle = () => {
    const nextState = !isConditional;
    setIsConditional(nextState);

    if (nextState) {
      setShowConditionalTooltip(false);
      setTimeout(() => setShowConditionalTooltip(false), 5000);
    } else {
      setShowConditionalTooltip(true);
    }
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matches800 ? '95%' : '800px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          paddingBottom: matches700 && '15px',
          // padding:  matchessm ? "30px 20px" :  "30px",
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid container xs={12} sx={{ padding: '30px' }}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {profileDetails?.PropertyDetails?.propertyAddress?.streetName}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <PendingWarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Initiate Private Offer
            </Typography>
          </Grid>
          <Grid
            item
            // xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            paddingTop={'10px'}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '14px' : '16px',
                width: 'auto',
                color: '#666666',
              }}
              // whiteSpace={"nowrap"}
            >
              You are about to initiate a private offer to the vendor {''}
              {fullName}
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: '1px solid lightgrey', width: '100%' }}></Box>

        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '20px',
            margin: '30px',
          }}
        >
          <Grid xs={12}>
            <Typography
              sx={{ fontFamily: 'poppins', fontSize: '24px', fontWeight: 400 }}
            >
              Deposit Summary
            </Typography>
          </Grid>
          <Grid
            xs={12}
            sx={{
              ...flexStyle,
              flexDirection: matches500 ? 'column' : 'row', // stack on mobile
              alignItems: matches500 ? 'flex-start' : 'center', // adjust alignment for mobile
            }}
          >
            <Typography
              sx={{
                ...reqStyle,
                width: matches500 ? '100%' : reqStyle.width, // full width on mobile
                mb: matches500 ? 1 : 0,
              }}
            >
              Offer Amount:
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: matches500 ? 'flex-start' : 'center',
                gap: '15px',
                flexWrap: 'wrap',
                width: matches500 ? '100%' : 'auto', // full width on mobile
              }}
            >
              <TextField
                variant="outlined"
                fullWidth={matches500}
                value={offerAmount}
                onChange={handleOfferAmountChange}
                ref={offerInputRef}
                error={!offerAmount && errors.offerAmount} // only show red when empty
                helperText={
                  !offerAmount && errors.offerAmount
                    ? 'Offer amount is required'
                    : ''
                }
                FormHelperTextProps={{
                  sx: {
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    marginLeft: 0,
                    color: '#d32f2f', // red when active
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography
                        sx={{
                          background: 'transparent',
                          padding: '0 10px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '20px',
                          fontWeight: 600,
                          fontFamily: 'Poppins',
                        }}
                      >
                        $
                      </Typography>
                    </InputAdornment>
                  ),
                  sx: {
                    fontSize: matches750 ? '16px' : '20px',
                    height: '50px',
                    fontWeight: 400,
                    fontFamily: 'Poppins',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '20px',
                    fontWeight: 400,
                    fontFamily: 'Poppins',
                  },
                }}
                sx={{
                  width: matches500 ? '100%' : '80%',
                  '& .MuiInputBase-input::placeholder': {
                    fontSize: matches750 ? '14px' : '20px',
                    fontWeight: 400,
                    fontFamily: 'Poppins',
                  },
                  // override red border when field is filled
                  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline':
                    {
                      borderColor: !offerAmount ? '#d32f2f' : '#ccc',
                    },
                }}
              />
            </Box>
          </Grid>

          <Grid
            xs={12}
            sx={{
              ...flexStyle,
              flexDirection: matches500 ? 'column' : 'row',
              flexWrap: matches400 ? 'wrap' : 'nowrap',
            }}
          >
            <Typography
              sx={{
                ...reqStyle,
                width: matches500 ? '100%' : '30%',
                textAlign: matches500 ? 'start' : 'left',
                marginBottom: matches500 ? '8px' : 0,
              }}
            >
              Deposit Amount:
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: {
                  xs: 'column',
                  sm: 'row',
                },
                alignItems: {
                  xs: 'stretch',
                  sm: 'center',
                },
                gap: '15px',
                flexWrap: 'wrap',
                width: '100%',
                marginLeft: matchessm ? 0 : '10%',
              }}
            >
              {/* Percent input */}
              <Box
                sx={{
                  width: '85px',
                  mx: { xs: 'auto', sm: 0 },
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <TextField
                  variant="outlined"
                  error={!depositPercent && errors.depositAmount}
                  inputProps={{
                    maxLength: 3,
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    style: {
                      fontFamily: 'Poppins',
                      padding: '10px 8px',
                      textAlign: 'center',
                    },
                  }}
                  value={depositPercent}
                  onChange={handleDepositPercentChange}
                  // helperText={
                  //   !depositPercent && errors.depositAmount
                  //     ? "Enter the Percentage or Amount"
                  //     : ""
                  // }
                  FormHelperTextProps={{
                    sx: {
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      marginLeft: 0,
                      color: '#d32f2f',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography
                          sx={{
                            fontSize: '16px',
                            fontFamily: 'Poppins',
                            fontWeight: 600,
                            lineHeight: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            height: '100%',
                          }}
                        >
                          %
                        </Typography>
                      </InputAdornment>
                    ),
                    sx: {
                      height: '44px',
                    },
                  }}
                  sx={{
                    width: '100%',
                    height: '44px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '5px',
                      height: '44px',
                      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#d32f2f',
                      },
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '10px 8px',
                      textAlign: 'center',
                    },
                  }}
                />
              </Box>

              {/* OR text */}
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: {
                    xs: '16px',
                    sm: '18px',
                    md: '20px',
                  },
                  color: 'lightgrey',
                  textAlign: 'center',
                  width: {
                    xs: '100%',
                    sm: 'auto',
                  },
                }}
              >
                OR
              </Typography>

              {/* Dollar input */}
              <TextField
                variant="outlined"
                inputProps={{
                  maxLength: 11,
                  style: { fontFamily: 'Poppins' },
                  pattern: '[0-9]*',
                }}
                style={{
                  opacity: amountDis ? 0.5 : 1,
                  pointerEvents: amountDis ? 'none' : 'auto',
                }}
                value={formattedTotalAmount}
                onChange={handleDepositAmountChange}
                inputRef={depositInputRef}
                error={!formattedTotalAmount && errors.depositAmount}
                helperText={
                  !formattedTotalAmount && errors.depositAmount
                    ? 'Enter the Percentage or Amount'
                    : ''
                }
                FormHelperTextProps={{
                  sx: {
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    marginLeft: 0,
                    color: '#d32f2f',
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        minWidth: 'auto',
                        justifyContent: { xs: 'center', sm: 'flex-start' },
                        width: { xs: '30px', sm: 'auto' },
                      }}
                    >
                      <Typography
                        sx={{
                          background: 'transparent',
                          padding: { xs: '0 2px', sm: '0 10px' },
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: { xs: '16px', sm: '18px', md: '20px' },
                          fontWeight: 600,
                          fontFamily: 'Poppins',
                          marginRight: matchessm ? -20 : 0,
                        }}
                      >
                        $
                      </Typography>
                    </InputAdornment>
                  ),
                  sx: {
                    fontSize: { xs: '14px', sm: '16px', md: '20px' },
                    height: '50px',
                    fontWeight: 400,
                    fontFamily: 'Poppins',
                    '& .MuiInputBase-input': {
                      paddingLeft: { xs: '2px', sm: 'inherit' },
                      textAlign: { xs: 'center', sm: 'left' },
                    },
                  },
                }}
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  '& .MuiInputBase-input::placeholder': {
                    fontSize: { xs: '14px', sm: '16px', md: '20px' },
                    fontWeight: 400,
                    fontFamily: 'Poppins',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f',
                    },
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid
            xs={12}
            sx={{
              ...flexStyle,
              flexDirection: matches500 ? 'column' : 'row',
              flexWrap: matches400 ? 'wrap' : 'nowrap',
              alignItems: matches500 ? 'flex-start' : 'center',
            }}
          >
            <Typography
              sx={{
                ...reqStyle,
                width: matches500 ? '100%' : '30%',
                marginBottom: matches500 ? '8px' : 0,
                textAlign: matches500 ? 'start' : 'left',
              }}
            >
              Proposed Settlement:
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: matches500 ? 'column' : 'row',
                alignItems: matches500 ? 'flex-start' : 'center',
                gap: '10px',
                width: matches500 ? '100%' : 'auto',
              }}
            >
              <Box sx={{ width: matches500 ? '100%' : 'auto' }}>
                <TextField
                  value={settlementDays}
                  onChange={handleSettlementDaysChange}
                  error={errors.settlementDays}
                  helperText={
                    errors.settlementDays
                      ? 'Settlement days is required'
                      : ' '
                  }
                  variant="outlined"
                  inputProps={{
                    maxLength: 3,
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    style: {
                      fontFamily: 'Poppins',
                      textAlign: 'center',
                      padding: '12px 8px',
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      fontFamily: 'Poppins',
                      fontSize: '13px',
                      marginLeft: 0,
                      marginTop: '4px',
                      color: '#d32f2f',
                    },
                  }}
                  InputProps={{
                    sx: {
                      fontSize: matches750 ? '14px' : '16px',
                      fontFamily: 'Poppins',
                      height: '44px',
                    },
                  }}
                  sx={{
                    width: matches500 ? '100%' : '80px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '5px',
                      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#d32f2f',
                      },
                    },
                  }}
                />
              </Box>

              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: matches800 ? '12px' : '16px',
                  marginTop: matches500 ? '5px' : 0,
                }}
              >
                {settlementDays && Number(settlementDays) > 0
                  ? Number(settlementDays) === 1
                    ? 'day after the exchanged contract date.'
                    : 'days after the exchanged contract date.'
                  : 'days after the exchanged contract date.'}
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              ...flexStyle,
              flexDirection: matches500 ? 'column' : 'row',
              alignItems: matches500 ? 'flex-start' : 'center',
            }}
          >
            {/* Accepted Contracts Label */}
            <Typography
              sx={{
                ...reqStyle,
                width: matches500 ? '100%' : reqStyle.width,
                fontFamily: 'poppins',
                mb: matches500 ? 1 : 0,
              }}
            >
              Accepted Contracts:
            </Typography>

            {/* Tooltip icon and toggle section */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                ml: matches500 ? 0 : 2,
              }}
            >
              {/* Tooltip (only show in Unconditional mode) */}
              {isConditional === 0 && (
                <Tooltip
                  open={showConditionalTooltip}
                  placement={matches500 ? 'right' : 'top'}
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: matches500 ? [-100, -100] : [150, 8],
                        },
                      },
                    ],
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                      },
                    },
                  }}
                  title={
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2,
                        minWidth: matches500 ? 300 : 476,
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 2,
                        backgroundColor: 'white',
                        boxShadow: '0px 0px 3px rgba(0,0,0,0.25)',
                      }}
                    >
                      <InfoOutlinedIcon
                        sx={{ color: '#1976d2', fontSize: 40 }}
                      />
                      <Typography
                        sx={{ fontSize: '14px', fontFamily: 'poppins' }}
                      >
                        By making this selection you are able to restrict buyers
                        from accepting the private offer until they have terms
                        agreed and are in an unconditional position.
                      </Typography>
                    </Paper>
                  }
                >
                  <IconButton
                    size="small"
                    sx={{
                      p: 0,
                      mb: 1,
                      ml: matches500 ? 0 : '-383px',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowConditionalTooltip((prev) => !prev); // ✅ Toggle true/false
                    }}
                  >
                    <InfoOutlinedIcon
                      fontSize="small"
                      sx={{ color: '#1976d2' }}
                    />
                  </IconButton>
                </Tooltip>
              )}

              {/* Toggle with "All" on left and "Unconditional" on right */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                {/* Label - All */}
                <span
                  style={{
                    fontWeight: 400,
                    color: isConditional === 1 ? '#000' : '#999',
                    fontFamily: 'poppins',
                  }}
                >
                  All
                </span>

                {/* Toggle */}
                <Box
                  onClick={() => {
                    const nextState = isConditional === 1 ? 0 : 1;
                    setIsConditional(nextState);

                    if (nextState === 0) {
                      setShowConditionalTooltip(true); // Auto show
                      setTimeout(() => setShowConditionalTooltip(false), 5000); // Auto-hide after 5s
                    } else {
                      setShowConditionalTooltip(false); // Hide tooltip
                    }
                  }}
                  sx={{
                    width: 48,
                    height: 24,
                    borderRadius: 999,
                    backgroundImage:
                      'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s',
                  }}
                >
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      backgroundColor: '#fff',
                      position: 'absolute',
                      top: '50%',
                      left: isConditional === 1 ? '4px' : '24px',
                      transform: 'translateY(-50%)',
                      transition: 'left 0.3s',
                    }}
                  />
                </Box>

                {/* Label - Unconditional */}
                <span
                  style={{
                    fontWeight: 400,
                    color: isConditional === 0 ? '#000' : '#999',
                    fontFamily: 'poppins',
                  }}
                >
                  Unconditional
                </span>
              </Box>
            </Box>
          </Grid>

          <Grid
            xs={12}
            sx={{
              ...flexStyle,
              flexDirection: matches500 ? 'column' : 'row',
              flexWrap: matches400 ? 'wrap' : 'nowrap',
              alignItems: matches500 ? 'flex-start' : 'center',
            }}
          >
            <Typography
              sx={{
                ...reqStyle,
                width: matches500 ? '100%' : '30%',
                marginBottom: matches500 ? '8px' : 0,
                textAlign: matches500 ? 'start' : 'left',
              }}
            >
              Message to Vendor:
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: matches500 ? '100%' : '60%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '15px',
                  width: '100%',
                }}
              >
                <TextField
                  multiline
                  rows={matches500 ? 3 : 4}
                  fullWidth
                  variant="outlined"
                  placeholder="Type your message here..."
                  value={vendorMessage}
                  onChange={(e) => setVendorMessage(e.target.value)}
                  FormHelperTextProps={{
                    sx: {
                      fontFamily: 'Poppins',
                      fontSize: '14px', // adjust as needed
                      marginLeft: 0, // optional, for alignment
                    },
                  }}
                  error={Boolean(errors.message) && vendorMessage.trim() === ''}
                  helperText={
                    Boolean(errors.message) && vendorMessage.trim() === ''
                      ? 'Message is required'
                      : ' '
                  }
                  InputProps={{
                    sx: {
                      fontSize: matches750 ? '14px' : '18px',
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                    },
                  }}
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '5px',
                    },
                    '& .MuiInputBase-input': {
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                    },
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction="row"
          sx={{ display: 'flex', alignItems: 'center' }}
          justifyContent={'flex-end'}
          gap={2}
          // marginTop={ matchessm ? "15px" : 5}
          marginBottom={'30px'}
          marginRight={'30px'}
        >
          <Grid item>
            <Button
              variant="outlined"
              sx={{
                padding: matchessm ? '6px 30px' : '10px 50px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={() => {
                setOfferAmount('');
                setFormattedTotalAmount('');
                // setDepositPercent("");
                // setSettlementDays("");
                setVendorMessage('');
                setErrors({
                  offerAmount: false,
                  depositAmount: false,
                  settlementDays: false,
                  message: false,
                });
                // setIsConditional(false);
                onClose();
                setShowConfirmationPopup(false); // close the dialog after reset
              }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid
            item
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              gap: '10px', // small gap between button and loader
            }}
          >
            <Button
              variant="outlined"
              disabled={loading || depositAmount < 1}
              sx={{
                padding: matchessm ? '6px 30px' : '10px 50px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#FFFFFF',
                fontWeight: '400',
                backgroundColor: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
                '&:hover': { backgroundColor: '#4CA4D6' },
                '&.Mui-disabled': {
                  backgroundColor: '#4CA4D6',
                  color: '#fff',
                  opacity: 0.7,
                  cursor: 'not-allowed',
                  pointerEvents: 'auto',
                },
              }}
              onClick={() => {
                handleSubmit();
                setShowConfirmationPopup(false);
              }}
            >
              Submit
            </Button>

            {loading ? (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }}
              />
            ) : (
              ''
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default InitiatePrivateOffer;
